import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import AccountMenu, { SHOW_SIGN_IN } from "./AccountMenu";
import { useAuth } from "../../context/AuthContext";

const Header = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    // { path: "/about", label: "About Us" },

    { path: "/service", label: "Services" },
    { path: "/balls", label: "Balls" },
    { path: "/shoes", label: "Shoes" },
    { path: "/contact", label: "Contact Us" },
  ];

  const isActive = (path) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const headerStyle = {
    background: "linear-gradient(to right, #000000, #0891b2)",
    color: "white",
    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
    position: "fixed",
    width: "100%",
    top: 0,
    zIndex: 50,
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "1rem 1.5rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const logoStyle = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "white",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    transition: "color 0.3s ease",
    cursor: "pointer",
  };

  const logoImageStyle = {
    height: "40px",
    width: "auto",
  };

  const logoTextStyle = {
    fontSize: "1.5rem",
    whiteSpace: "nowrap",
  };

  // Desktop navigation
  const navStyle = {
    display: "flex",
    listStyle: "none",
    gap: "2rem",
    margin: 0,
    padding: 0,
  };

  // Mobile navigation
  const mobileNavStyle = {
    display: "none",
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    background: "linear-gradient(to right, #000000, #0891b2)",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "1rem 0",
  };

  const mobileNavOpenStyle = {
    ...mobileNavStyle,
    display: "block",
  };

  const mobileNavListStyle = {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  };

  const mobileNavItemStyle = {
    padding: "0.75rem 1.5rem",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  };

  const linkStyle = {
    color: "white",
    textDecoration: "none",
    fontWeight: "500",
    padding: "0.5rem 0.75rem",
    borderRadius: "4px",
    transition: "all 0.3s ease",
    display: "block",
    cursor: "pointer",
  };

  const activeLinkStyle = {
    ...linkStyle,
    color: "#22d3ee",
    backgroundColor: "rgba(34, 211, 238, 0.2)",
    borderBottom: "2px solid #22d3ee",
  };

  // Hamburger menu button
  const hamburgerStyle = {
    display: "none",
    flexDirection: "column",
    cursor: "pointer",
    padding: "0.5rem",
    background: "none",
    border: "none",
    gap: "4px",
  };

  const hamburgerLineStyle = {
    width: "25px",
    height: "3px",
    backgroundColor: "white",
    transition: "all 0.3s ease",
  };

  const hamburgerLineTopStyle = {
    ...hamburgerLineStyle,
    transform: isMobileMenuOpen ? "rotate(45deg) translate(5px, 5px)" : "none",
  };

  const hamburgerLineMiddleStyle = {
    ...hamburgerLineStyle,
    opacity: isMobileMenuOpen ? 0 : 1,
  };

  const hamburgerLineBottomStyle = {
    ...hamburgerLineStyle,
    transform: isMobileMenuOpen
      ? "rotate(-45deg) translate(7px, -6px)"
      : "none",
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 1100px) {
            .desktop-nav-list {
              gap: 0.5rem !important;
            }
          }

          @media (max-width: 768px) {
            .desktop-nav {
              display: none !important;
            }
            .mobile-hamburger {
              display: flex !important;
            }
            .logo-text {
              font-size: 1.2rem !important;
            }
            .logo-image {
              height: 35px !important;
            }
            .header-container {
              padding: 0.75rem 1rem !important;
            }
          }
          
          @media (max-width: 480px) {
            .logo-text {
              font-size: 1rem !important;
            }
            .logo-image {
              height: 30px !important;
            }
          }
        `}
      </style>

      <header style={headerStyle}>
        <div style={containerStyle} className="header-container">
          <Link to="/" style={logoStyle}>
            <img
              src={Logo}
              alt="900 Pro Shop"
              style={logoImageStyle}
              className="logo-image"
            />
            <span style={logoTextStyle} className="logo-text">
              900 Pro Shop
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav
            className="desktop-nav"
            style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
          >
            <ul style={navStyle} className="desktop-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    style={isActive(item.path) ? activeLinkStyle : linkStyle}
                    onMouseEnter={(e) => {
                      if (!isActive(item.path)) {
                        e.target.style.color = "#dc143c";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive(item.path)) {
                        e.target.style.color = "white";
                      }
                    }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <AccountMenu />
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            style={hamburgerStyle}
            className="mobile-hamburger"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span style={hamburgerLineTopStyle}></span>
            <span style={hamburgerLineMiddleStyle}></span>
            <span style={hamburgerLineBottomStyle}></span>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        <nav style={isMobileMenuOpen ? mobileNavOpenStyle : mobileNavStyle}>
          <ul style={mobileNavListStyle}>
            {navItems.map((item) => (
              <li key={item.path} style={mobileNavItemStyle}>
                <Link
                  to={item.path}
                  style={isActive(item.path) ? activeLinkStyle : linkStyle}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            {user ? (
              <>
                <li style={mobileNavItemStyle}>
                  <Link
                    to="/account"
                    style={
                      location.pathname.startsWith("/account") ? activeLinkStyle : linkStyle
                    }
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Account
                  </Link>
                </li>
                <li style={mobileNavItemStyle}>
                  <button
                    type="button"
                    style={{
                      ...linkStyle,
                      background: "none",
                      border: "none",
                      font: "inherit",
                      fontWeight: "500",
                    }}
                    onClick={() => {
                      setIsMobileMenuOpen(false);
                      signOut();
                    }}
                  >
                    Sign out
                  </button>
                </li>
              </>
            ) : SHOW_SIGN_IN ? (
              <li style={mobileNavItemStyle}>
                <Link
                  to="/login"
                  style={isActive("/login") ? activeLinkStyle : linkStyle}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Sign in
                </Link>
              </li>
            ) : null}
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
